import { Button, Typography } from "@mui/material";
import { LoadingButton } from "@routes-plan/ui";
import { SyntheticEvent, useState } from "react";
import StandardModal from "../../../../components/modales/StandardModal";
import { useT } from "../../../../i18n";

interface MyModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (event: SyntheticEvent) => Promise<void> | void;
    title?: string;
}

const ConfirmDayClosingModal: React.FC<MyModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title
}) => {
    const t = useT();
    // Cargando propio mientras se ejecuta la confirmación.
    const [working, setWorking] = useState(false);

    const handleConfirm = async (event: SyntheticEvent) => {
        setWorking(true);
        try {
            await onConfirm(event);
        } finally {
            setWorking(false);
        }
    };

    return (
        <StandardModal
            open={isOpen}
            onClose={onClose}
            title={t('routeSettlement.confirmTitle')}
            maxWidth={500}
            loading={working}
            disableClose={working}
            actions={
                <>
                    <Button variant="outlined" color="inherit" onClick={onClose} disabled={working}>
                        {t('common.cancel')}
                    </Button>
                    <LoadingButton variant="contained" onClick={handleConfirm} loading={working}>
                        {t('routeSettlement.settle')}
                    </LoadingButton>
                </>
            }
        >
            <Typography>{title ?? t('routeSettlement.confirmQuestion')}</Typography>
        </StandardModal>
    );
};

export default ConfirmDayClosingModal;
